<template>
  <!-- Main -->
  <div id="main">
    <!-- Post -->
    <section class="post" v-if="this.$route.path==='/contacts'">
      <header>
        <h3>{{contactsData.full_company_name}} ({{contactsData.company_name}})</h3>
      </header>

      <section class="contacts">
        <h2>Адреса и телефоны архива</h2>
       <!-- <h3 style="color: rgb(230, 0, 0);">Внимание, архив работает без предварительной записи
          <a href="PF5gCcTC">(подробнее)</a>
        </h3> -->
        {{this.$route.hash}}
        <!--{{tabIndex}}-->
        <b-tabs content-class="mt-0 box" v-model="tabIndex">
          <b-tab
            v-for="building in contactsData.buildings"
            v-bind:key="building.id"
            :title="building.name"
          >
            <h3 v-if="building.id===1">
                Подразделение по работе с архивными документами государственных органов
            </h3>
            <h3 v-if="building.id===2">
                Подразделение по работе с архивными документами государственных органов
            </h3>
            <h3 v-if="building.id===3">
                Подразделение по работе с архивными документами государственных органов
            </h3>
            <h3 v-if="building.id===4">
                Подразделение по работе с архивными документами КПСС и общественных организаций
            </h3>
            <h3 v-if="building.id===5">
                Подразделение по работе с архивными документами по личному составу
            </h3>

            <h3>Режимы работы:</h3>

            <!--<div class="table-wrapper">
              <h3>Режимы работы:</h3>
              <table class="contacts">
                <tbody>
                  <tr>
                    <td
                      v-for="(work, wIndex) in building.work_time"
                      v-bind:key="wIndex"
                    >
                      <h4>{{work.title}}</h4>
                      <ul>
                        <li
                          v-for="(interval, iIndex) in work.regime"
                          v-bind:key="iIndex"
                        >
                          <b>{{interval.title}}:</b> {{interval.from}} — {{interval.to}}
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>-->

            <b-row class="worktimes-list m-0 pb-5">
              <b-col
                class="worktimes col-12 col-xl-4"
                v-for="(work, wIndex) in building.work_time"
                v-bind:key="wIndex"
              >
                <h4>{{work.title}}</h4>
                <ul>
                  <li
                    v-for="(interval, iIndex) in work.regime"
                    v-bind:key="iIndex"
                  >
                    <b>{{interval.title}}:</b> {{interval.from}} — {{interval.to}}
                  </li>
                </ul>
              </b-col>
            </b-row>

            <b-row class="additional-info pb-5 m-0">
              <b-col class="item col-12 col-xl-6">
                <iframe :src="building.road_map" width="100%" height="500" frameborder="0">
                </iframe>
              </b-col>
              <b-col
                class="item col-12 col-xl-6"
                v-if="building.additional_info && building.additional_info.length > 0"
              >
                <ul>
                  <li v-for="(info, iIndex) in building.additional_info" v-bind:key="iIndex">
                    <b>{{info.title}}: </b>{{info.value}}
                  </li>
                </ul>
              </b-col>
            </b-row>

            <!--<div class="table-wrapper">
              <table class="contacts">
                <tbody>
                  <tr
                    v-for="contact in building.employee_contacts"
                    v-bind:key="contact.cid"
                  >
                    <td class="photo" v-if="contact.photo">
                      <div class="photo-wrapper">
                        <img v-if="contact.photo" :src="'/static/contact_photos/'+contact.photo"
                        alt="Фотокарточка">
                        <img v-else :src="'/static/contact_photos/default.png'"
                        alt="Фотокарточка">
                        <div></div>
                      </div>
                    </td>
                    <td v-bind:colspan="contact.photo ? 0 : 2">
                      <p>
                        <b>{{contact.post}}</b> —
                        {{contact.surname}} {{contact.name}} {{contact.patronymic}}
                      </p>
                      <p><a :href="`mailto:${contact.email}`">{{contact.email}}</a></p>
                      <p><b>{{contact.phone}}</b></p>
                    </td>
                  </tr>
                </tbody>
              </table></div>-->

            <b-row
              class="contact-container m-0"
              v-for="contact in building.employee_contacts"
              v-bind:key="contact.cid"
            >
              <b-col
                v-if="contact.photo"
                class="contact-photo my-aut my-auto"
              >
                <img
                  v-if="contact.photo"
                  :src="'/static/contact_photos/'+contact.photo"
                  alt="Фотокарточка"
                >
                <img
                  v-else
                  :src="'/static/contact_photos/default.png'"
                  alt="Фотокарточка"
                >
              </b-col>
              <b-col
                class="contact-data my-auto"
              >
                <p>
                  <b>{{contact.post}}</b> —
                    {{contact.surname}} {{contact.name}} {{contact.patronymic}}
                </p>
                <!--<p><a :href="`mailto:${contact.email}`">{{contact.email}}</a></p>-->
                <p><b>{{contact.phone | phone}}</b></p>
              </b-col>
            </b-row>

          </b-tab>
        </b-tabs>

      </section>

      <section class="box">
        <div>
          <h2>Реквизиты учреждения</h2>
        </div>
        <div>
          <ul class="requisites">
            <li
              v-for="(requisite, rIndex) in contactsData.requisites"
              v-bind:key="rIndex"
            >
              <b>{{requisite.title}}:</b> {{requisite.value}}
            </li>
          </ul>
        </div>
      </section>

    </section>

    <template v-else-if="this.$route.path==='/news'">

      <b-pagination-nav
        class="text-center"
        :number-of-pages="pagesNews.pages"
        :pages="pagination"
        use-router
        align="center"
        :first-text="'«'"
        :prev-text="'‹'"
        :next-text="'›'"
        :last-text="'»'"
      ></b-pagination-nav>

      <div class="one-panel">

        <section class="posts">
          <article class="half-image" v-for="page in pagesNews.results" v-bind:key="page.uri">
            <header>
              <span class="date">
                {{$options.filters.moment(page.creation_date, 'MMMM DD, YYYY')}}
              </span>
              <h3>
                  <router-link
                    :to="{ name: 'SinglePage', params: { uri: page.uri }}"
                  >{{page.title}}</router-link>
              </h3>
            </header>
            <router-link
              :to="{ name: 'SinglePage', params: { uri: page.uri }}"
              class="image fit"
            >
              <img :src="'/static/page_covers/'+page.cover" alt="" />
            </router-link>
            <p class="line-clamp">{{page.seo_description}}</p>
            <router-link
              :to="{ name: 'SinglePage', params: { uri: page.uri }}"
              class="button w-100"
            >Смотреть полностью</router-link>
          </article>
        </section>
      </div>

      <b-pagination-nav
        class="text-center"
        :number-of-pages="pagesNews.pages"
        :pages="pagination"
        use-router
        align="center"
        :first-text="'«'"
        :prev-text="'‹'"
        :next-text="'›'"
        :last-text="'»'"
      ></b-pagination-nav>

    </template>

    <section class="post" v-else>
      <header class="major">
        <!--<span class="date">
          {{$options.filters.moment(this.pageData.creation_date, 'MMMM DD, YYYY')}}
        </span>-->
        <h1>
          {{this.pageData.title}}
        </h1>
        <p>
          {{this.pageData.seo_description}}
        </p>
      </header>

      <carousel
        :autoplay="false"
        :slideOnSwipe="false"
        v-if="pageData.gallery && pageData.gallery.length > 0"
        :data="pageData.gallery"
        class="w-100 mb-3"
      >
      </carousel>

      <div v-html="this.pageData.text">
      </div>

      <template
        v-if="this.pageData.files && this.pageData.files.length > 0"
      >
        <h3>Приложения:<a name="downloads"></a></h3>
        <ol>
          <li
            v-for="file in this.pageData.files"
            :key="file.fid"
          >
            <a :href="'/static/page_files/'+file.fname">
              {{file.name}} <i>({{file.extension}}, {{file.size}})</i>
            </a>
          </li>
        </ol>
      </template>
    </section>

  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SinglePage',
  data() {
    return {
      pagination: [],
      tabIndex: 1,
    };
  },
  computed: mapState({
    pageData: state => state.pageData,
    contactsData: state => state.contactsData,
    pagesNews: state => state.pagesNews,
  }),
  components: {
  },
  created() {
    this.fetchData();
  },
  mounted() {
    this.tabIndex = 3;
  },
  watch: {
    $route: 'fetchData',
    pageData: function galleryHandler(pageData) {
      if (pageData.gallery && pageData.gallery.length > 0) {
        pageData.gallery.forEach((image) => {
          this.$set(
            image,
            'content',
            createElement => (
              createElement('a', {
                attrs: {
                  href: `/static/page_gallery/${image.fname}`,
                  target: '_blank',
                },
              },
              [
                createElement('div', {
                  class: 'slide',
                },
                [
                  createElement('div', {
                    attrs: {
                      style: `background-image:url(/static/page_gallery/${image.fname})`,
                    },
                    class: '',
                  }),
                  createElement('span', [`${image.name}`]),
                ]),
              ])
            ),
          );
        });
      }
    },
    pagesNews: function paginationHandler(pagesNews) {
      this.pagination = [];
      for (let i = 0; i < pagesNews.pages; i += 1) {
        this.pagination.push({ link: { query: { start: (i * 6) + 1, limit: 6 } }, text: i + 1 });
      }
    },
  },
  methods: {
    fetchData() {
      this.$store.dispatch('loadPageData', { uri: this.$route.params.uri });
      if (this.$route.path === '/contacts') {
        this.$store.dispatch('loadContactsData');
        this.tabIndex = 2;
      }
      if (this.$route.path === '/news') {
        this.$store.dispatch('loadPagesNews', { start: this.$route.query.start, limit: this.$route.query.limit });
      }
    },
  },
  filters: {
    phone(value) {
      let stripped = value.replace(/\s/g, '');
      stripped = stripped.match(/.{1,12}/g);
      let number = stripped[0].match(/^(\+\d{1}|)?(\d{4})(\d{2})(\d{2})(\d{2})$/);
      if (number) {
        number = [number[1], ' (', number[2], ') ', number[3], '-', number[4], '-', number[5]].join('');
        if (stripped[1]) {
          number = [number, stripped[1]].join(' ');
        }
        return number;
      }
      return value;
    },
  },
};
</script>
